// extracted by mini-css-extract-plugin
export default {"form":"form---MQ_3K","formContent":"formContent---QFH4N"};